import React from "react";
import { Link } from "react-router-dom";
import { useCart } from "../contexts/CartContext";
import { Plus, Minus, Timer } from "lucide-react";

export default function ProductCard({ product, shop, variant = "grid" }) {
  const cart = useCart();
  const inCart = cart.cart.items[product.product_id];

  const add = (e) => {
    e.preventDefault();
    e.stopPropagation();
    cart.addItem(product, shop);
  };
  const dec = (e) => {
    e.preventDefault();
    e.stopPropagation();
    cart.decrement(product.product_id);
  };

  return (
    <Link
      to={`/product/${product.product_id}`}
      data-testid={`product-card-${product.product_id}`}
      className={`ls-card tilt-card relative rounded-2xl flex flex-col ${variant === "grid" ? "" : "min-w-[160px] sm:min-w-[180px]"}`}
    >
      <div className="relative rounded-t-2xl overflow-hidden bg-slate-50 aspect-square">
        <img
          src={product.image_url}
          alt={product.name}
          loading="lazy"
          className="absolute inset-0 w-full h-full object-cover"
          style={{ transform: "translateZ(0)" }}
        />
        <div className="absolute top-2 left-2 inline-flex items-center gap-1 ls-pill-10min text-[10px] font-bold rounded-full px-2 py-0.5">
          <Timer size={10} /> 10 MIN
        </div>
        {product.price >= 199 && (
          <div className="absolute top-2 right-2 bg-rose-500 text-white text-[10px] font-bold rounded px-1.5 py-0.5 rotate-[-6deg]">
            FREE DEL
          </div>
        )}
      </div>
      <div className="p-3 flex flex-col flex-1 gap-1">
        <div className="font-semibold text-sm text-slate-900 leading-tight line-clamp-2 min-h-[2.4rem]">
          {product.name}
        </div>
        <div className="text-[11px] text-slate-500">{product.unit}</div>
        <div className="mt-auto pt-2 flex items-end justify-between">
          <div>
            <div className="font-extrabold text-base text-slate-900 leading-none">₹{product.price}</div>
            {product.mrp && product.mrp > product.price && (
              <div className="text-[11px] text-slate-400 line-through leading-none mt-0.5">₹{product.mrp}</div>
            )}
          </div>
          {!inCart ? (
            <button
              onClick={add}
              className="ls-add-btn rounded-lg px-3 py-1.5 text-xs"
              data-testid={`product-add-btn-${product.product_id}`}
            >
              ADD
            </button>
          ) : (
            <div className="inline-flex items-center rounded-lg overflow-hidden">
              <button className="ls-step-btn" onClick={dec} data-testid={`product-dec-${product.product_id}`}>
                <Minus size={12} />
              </button>
              <div className="w-7 h-7 inline-flex items-center justify-center bg-emerald-600 text-white text-xs font-bold">
                {inCart.qty}
              </div>
              <button className="ls-step-btn" onClick={add} data-testid={`product-inc-${product.product_id}`}>
                <Plus size={12} />
              </button>
            </div>
          )}
        </div>
      </div>
    </Link>
  );
}
